import { signUp } from "../AuthService"; // Load environment variables

// Define the base URL for the API from .env
// const BASE_URL = 'https://api.i2rtest.in/v1';

// const BASE_URL = 'https://event.i2rtest.in/v1'


// Define the base URL for the API
// const BASE_URL = 'https://testing-event.onrender.com/v1';
const BASE_URL = 'https://eventbackend.idea2reality.tech/v1';
// const BASE_URL = "http://localhost:8086/v1"


// Define the endpoints
const apis = {
    baseurl: {
        Baseimageurl: `https://eventbackend.idea2reality.tech/public/get-image/`
    },
    auth: {
        login: `${BASE_URL}/auth/auth/login`, // events web
        signUp: `${BASE_URL}/auth/register`,
        restaurant: `${BASE_URL}/auth/login-restaurant`
    },
    // sidemenu: { sidebarmenu: `${BASE_URL}/menus/sidebar-menus` },

    permission: { permission: `${BASE_URL}/permission/permissions` },
    roles: {
        role: `${BASE_URL}/private/role/create-role`,
        rolesList: `${BASE_URL}/private/role/roles-list`
    },
    zones: {
        AddZone: `${BASE_URL}/zones/add/zone`,
        zoneList: `${BASE_URL}/zones/zone/list`
    },
    employee: {
        createEmployee: `${BASE_URL}/auth/register`,
        employeeList: `${BASE_URL}/auth/admins`
    },
    cuisines: {
        addCuisines: `${BASE_URL}/auth/register`,
        cuisineList: `${BASE_URL}/cuisines/cusine-list`
    },
    restaurants: {
        addRestaurant: `${BASE_URL}/restaurant/add/restaurants`,
        restaurantsList: `${BASE_URL}/restaurant/restaurant-list`
    },
    categories: {
        addCategory: `${BASE_URL}/private/category/create-category`,
        categoriesList: `${BASE_URL}/private/category/category-list`,
        deleteCategorie: `${BASE_URL}/private/category/delete-category`,
        getCategoryById: `${BASE_URL}/private/category/category-list`,
        updateCategory: `${BASE_URL}/private/category/edit-category`,
        updateCategoryStatus: `${BASE_URL}/private/category/update-category-status`,

        getAllCategoriesListApi: `${BASE_URL}/private/category/categories`,

        // Sub Category
        getAllCategoryList: `${BASE_URL}/private/category/category-list`,
        addSubcategory: `${BASE_URL}/private/category/create-subcategory`,
        subCategoriesList: `${BASE_URL}/private/category/subcategory-list`,
        deleteSubCategorie: `${BASE_URL}/private/category/delete-subcategory`,
        getSubCategoryById: `${BASE_URL}/private/category/subcategory-list`,
        updateSubCategory: `${BASE_URL}/private/category/edit-subcategory`,

        getAllSubCategoriesListApi: `${BASE_URL}/private/category/subcategories`,

        // Sub Sub Category
        addSubSubcategory: `${BASE_URL}/private/category/create-subsubcategory`,
        subSubCategoriesList: `${BASE_URL}/private/category/subsubcategory-list`,
        deleteSubSubCategorie: `${BASE_URL}/private/category/delete-subsubcategory`,
        getSubSubCategoryById: `${BASE_URL}/private/category/subsubcategory-list`,
        updateSubSubCategory: `${BASE_URL}/private/category/edit-subsubcategory`,

        getAllSubSubCategoriesListApi: `${BASE_URL}/private/category/subsubcategories`,
    },

    addOns: {
        addAddons: `${BASE_URL}/addons/create-addon`,
        addOnsList: `${BASE_URL}/addons/addons-list`
    },
    food: {
        addFood: `${BASE_URL}/food/create-food`,
        foodList: `${BASE_URL}/food/food-list`,
        foodListById: `${BASE_URL}/food/food-item`,
        foodByRestaurantId: `${BASE_URL}/food/food-itemid`

    },
    vendor: {
        createVendor: `${BASE_URL}/private/vendor/create-vendor`,
    },

    agency:{
      createBasicInfo: `${BASE_URL}/auth/agency/basicinfo/create-agency`,
      createCompanyAddress: `${BASE_URL}/auth/agency/company-address/create-agency`,
      createSocialHandles: `${BASE_URL}/auth/agency/social-handle/create-agency`,
      createCompliance: `${BASE_URL}/auth/agency/compliance/create-agency`,

      // table
      agencyList: `${BASE_URL}/auth/agency/get-agencies`,
      deleteAgency: `${BASE_URL}/auth/agency/delete-agency`,
      getEditAgencyData: `${BASE_URL}/private/brand/brand-list`,
      updateAgency: `${BASE_URL}/private/brand/edit-brand`,
      updateAgencyStatus: `${BASE_URL}/private/brand/update-brand-status`,

      getAllAgencyList: `${BASE_URL}/private/brand/brands`,
    },

    getLatLng:{
      latlng: `https://nominatim.openstreetmap.org/search?postalcode`,
    },

    brands: {
        addBrand: `${BASE_URL}/private/brand/create-brand`,
        brandList: `${BASE_URL}/private/brand/brand-list`,
        deleteBrand: `${BASE_URL}/private/brand/delete-brand`,
        getEditBrandData: `${BASE_URL}/private/brand/brand-list`,
        updateBrand: `${BASE_URL}/private/brand/edit-brand`,
        updateBrandStatus: `${BASE_URL}/private/brand/update-brand-status`,

        getAllBrandList: `${BASE_URL}/private/brand/brands`,
    },

    fittingSize: {
        addFittingSize: `${BASE_URL}/private/fittingsizes/create-fitting-size`,
        fittingSizeList: `${BASE_URL}/private/fittingsizes/fitting-size-list`,
        deleteFittingSize: `${BASE_URL}/private/fittingsizes/delete-fitting-size`,
        getEditFittingSizeData: `${BASE_URL}/private/fittingsizes/fitting-size-list`,
        updateFittingSize: `${BASE_URL}/private/fittingsizes/edit-fitting-size`,
        updateFittingSizeStatus: `${BASE_URL}/private/fittingsizes/update-fitting-size-status`,

        getAllFittingSizeList: `${BASE_URL}/private/fittingsizes/all-fitting-sizes`,

    },

    thread: {
        addThread: `${BASE_URL}/private/threads/create-thread`,
        threadList: `${BASE_URL}/private/threads/thread-list`,
        deleteThread: `${BASE_URL}/private/threads/delete-thread`,
        getEditThreadData: `${BASE_URL}/private/threads/thread-list`,
        updateThread: `${BASE_URL}/private/threads/edit-thread`,
        updateThreadStatus: `${BASE_URL}/private/threads/update-thread-status`,

        getAllThreadList: `${BASE_URL}/private/threads/all-threads`,
    },

    material: {
        addMaterial: `${BASE_URL}/private/materials/create-material`,
        materialList: `${BASE_URL}/private/materials/materials-list`,
        deleteMaterial: `${BASE_URL}/private/materials/delete-material`,
        getEditMaterialData: `${BASE_URL}/private/materials/materials-list`,
        updateMaterial: `${BASE_URL}/private/materials/edit-material`,
        updateMaterialStatus: `${BASE_URL}/private/materials/update-material-status`,

        getAllMaterialList: `${BASE_URL}/private/materials/materials-list`,
    },

    product: {
        addProduct: `${BASE_URL}/private/products/create-product`,
        productList: `${BASE_URL}/private/products/get-products`,
        deleteProduct: `${BASE_URL}/private/products/delete-product`,
        getEditProductData: `${BASE_URL}/private/products/get-products`,
        updateProduct: `${BASE_URL}/private/products/edit-product`,
        updateProductStatus: `${BASE_URL}/private/products/update-product-status`,

        getAllProductList: `${BASE_URL}/private/products/get-all-products`,
    },

    variant: {
        addVariant: `${BASE_URL}/private/variants/create-variant`,
        variantList: `${BASE_URL}/private/variants/variant-list`,
        deleteVariant: `${BASE_URL}/private/variants/delete-variant`,
        getEditVariantData: `${BASE_URL}/private/variants/variant-list`,
        updateVariant: `${BASE_URL}/private/variants/edit-variant`,
        updateVariantStatus: `${BASE_URL}/private/variants/update-variant-status`,

        getAllThreadList: `${BASE_URL}/private/variants/all-variants`,
    },

    part: {
        addPart: `${BASE_URL}/private/parts/create-part`,
        partList: `${BASE_URL}/private/parts/parts-list`,
        deletePart: `${BASE_URL}/private/parts/delete-part`,
        getEditPartData: `${BASE_URL}/private/parts/parts-list`,
        updatePart: `${BASE_URL}/private/parts/edit-part`,
        updatePartStatus: `${BASE_URL}/private/parts/update-part-status`,

        getAllPartList: `${BASE_URL}/private/parts/parts-list`,
    },

    supplier: {
        addSupplier: `${BASE_URL}/private/suppliers/create-supplier`,
        supplierList: `${BASE_URL}/private/suppliers/supplier-list`,
        deleteSupplier: `${BASE_URL}/private/suppliers/delete-supplier`,
        getEditSupplierData: `${BASE_URL}/private/suppliers/supplier-list`,
        updateSupplier: `${BASE_URL}/private/suppliers/edit-supplier`,
        updateSupplierStatus: `${BASE_URL}/private/suppliers/update-supplier-status`,

        getAllSupplierList: `${BASE_URL}/private/suppliers/all-suppliers`,
    },

    purchaseorder: {
        addPurchaseOrder: `${BASE_URL}/private/purchaseorders/create-purchase-order`,
        createPoItem: `${BASE_URL}/private/purchaseorders/create-po-item`,
        purchase_OrderList: `${BASE_URL}/private/purchaseorders/purchase-order-list`,
        deletePurchaseOrder: `${BASE_URL}/private/suppliers/delete-supplier`,
        getEditPurchaseOrderData: `${BASE_URL}/private/suppliers/supplier-list`,
        updatePurchaseOrder: `${BASE_URL}/private/suppliers/edit-supplier`,
        updatePurchaseOrderStatus: `${BASE_URL}/private/suppliers/update-supplier-status`,
        getPurchaseOrderViewData: `${BASE_URL}/private/purchaseorders/purchase-order-list`,

        getPurchaseOrderItemsData: `${BASE_URL}/private/purchaseorders/po-items`,
        getPurchaseOrderCheckBill: `${BASE_URL}/private/pobills/check-bill`,

        getAllPurchaseOrderList: `${BASE_URL}/private/suppliers/all-suppliers`,

        //Bill apis
        addBillDetails: `${BASE_URL}/private/pobills/create-po-bill`,
        updatePOItems: `${BASE_URL}/private/purchaseorders/update-po-items`,
        createBillItems: `${BASE_URL}/private/pobills/create-pob-item`,
        returnOrderList: `${BASE_URL}/private/pobills/return-order-bills`,
        getReturnOrderViewData: `${BASE_URL}/private/pobills/return-orders`,
        updatePurchaseOrderStatus: `${BASE_URL}/private/purchaseorders/update-po-status`,

        getBillViewbyId: `${BASE_URL}/private/pobills/po-bill-details`,
        downloadBill: `${BASE_URL}/private/pobills/download-bill`,
    },

    common: {
        getStateList: `${BASE_URL}/public/states/states-list`
    },

    // event mangement --------------------------------------------------------
    // event mangement --------------------------------------------------------
    // event mangement --------------------------------------------------------
    // event mangement --------------------------------------------------------
    // event mangement --------------------------------------------------------
    // event mangement --------------------------------------------------------

    countryStateCity: {
        country: `${BASE_URL}/api/locations/countries`,
        state: `${BASE_URL}/api/locations/states`,
        city: `${BASE_URL}/api/locations/cities`,
    },

    sidemenu: { sidebarmenu: `${BASE_URL}/auth/sidemenu/sidebar-menus` },

    staff: {
        createAdminStaff: `${BASE_URL}/auth/admin_staff/create-admin-staff`,
        getAdminStaff: `${BASE_URL}/auth/admin_staff/get-admin-staff`,
        deleteStaff: `${BASE_URL}/auth/admin_staff/delete-admin-staff`,
        editStaffApi: `${BASE_URL}/auth/admin_staff/get-admin-staff`,
        updateStaffApi: `${BASE_URL}/auth/admin_staff/update-admin-staff`
    },

    basicInfo: {
        type: `${BASE_URL}/api/event/event-type`,
        category: `${BASE_URL}/api/event/event-category`,
        create: `${BASE_URL}/auth/events/basicinfo/create-event`,
        sehedule: `${BASE_URL}/auth/events/addschedule/create-event`
    },

    packages: {
        get: `${BASE_URL}/auth/package/get`,
        create: `${BASE_URL}/auth/events/package/create-event`,
        created_package_list: `${BASE_URL}/auth/events/package-list`
    },

    pitch: {
        create: `${BASE_URL}/auth/events/add-exhibitors-sponsors/create-event`
    },

    mediahub: {
        create: `${BASE_URL}/auth/events/media/create-event`,
    },

    speakerlist: {
        create: `${BASE_URL}/auth/events/speakerlist/create-event`,
    },

    terms: {
        create: `${BASE_URL}/auth/events/terms/create-event`,
    },

    socialMedia: {
        create: `${BASE_URL}/auth/events/social/create-event`,
    },

    currency: {
        get: `${BASE_URL}/auth/currency/get`,
        create: `${BASE_URL}/auth/currency/create`,
        delete: `${BASE_URL}/auth/currency/delete`,
        edit: `${BASE_URL}/auth/currency/get`,
        update: `${BASE_URL}/auth/currency/update`
    },

    allEvent: {
        get: `${BASE_URL}/auth/events/event-admin`,
        delete: `${BASE_URL}/auth/events/delete-event-type`,
        statusUpdate: `${BASE_URL}/auth/events/updatestatus/create-event`,
        eventdelete: `${BASE_URL}/auth/events/deleteevent/create-event`
    },

    eventType: {
        create: `${BASE_URL}/api/event/create-event-type`,
        get: `${BASE_URL}/api/event/event-type`,
        delete: `${BASE_URL}/api/event/delete-event-type`,
        edit: `${BASE_URL}/api/event/get-event-type`,
        update: `${BASE_URL}/api/event/update-event-type`
    },

    banner:{
     createBanner: `${BASE_URL}/auth/banner/create-admin-banner`,
    },

    packageName: {
        create: `${BASE_URL}/auth/package/create`,
        delete: `${BASE_URL}/auth/package/delete`,
        edit: `${BASE_URL}/auth/package/get`,
        update: `${BASE_URL}/auth/package/update`
    },

    attendee: {
        get: `${BASE_URL}/api/event/get-event-info`,
    }

}

export default apis;